import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { createPortal } from 'react-dom';

export type CopyToastState = { x: number; y: number; key: number } | null;

type Props = {
  toast: CopyToastState;
};

/**
 * Floating "Copied" confirmation pill rendered via portal so it escapes
 * overflow-clipped ancestors. Positioned above the click point in fixed coords.
 */
const CopyToast = ({ toast }: Props) => {
  const theme = useTheme();

  if (!toast) return null;

  const isDark = theme.palette.mode === 'dark';

  return createPortal(
    <Box
      key={toast.key}
      sx={{
        position: 'fixed',
        top: toast.y - 36,
        left: toast.x,
        pointerEvents: 'none',
        zIndex: 9999,
        px: 1.25,
        py: 0.5,
        borderRadius: '6px',
        fontSize: '12px',
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        color: isDark ? '#111' : '#fff',
        backgroundColor: isDark ? 'rgba(255,255,255,0.95)' : 'rgba(20,20,20,0.92)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
        animation: 'gfbCopyPill 1.1s ease forwards',
        '@keyframes gfbCopyPill': {
          '0%': { opacity: 0, transform: 'translate(-50%, 8px) scale(0.92)' },
          '15%': { opacity: 1, transform: 'translate(-50%, 0) scale(1)' },
          '75%': { opacity: 1, transform: 'translate(-50%, 0) scale(1)' },
          '100%': { opacity: 0, transform: 'translate(-50%, -6px) scale(1)' }
        }
      }}
    >
      <Box component="span" sx={{ color: isDark ? '#16a34a' : '#4ade80', fontWeight: 700 }}>
        ✓
      </Box>
      Copied
    </Box>,
    document.body
  );
};

export default CopyToast;
